// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1056":"8267dab49d6ccb47","1855":"fdc8da37fa70f9b6","5704":"8f01e4300a4d7bd7","7620":"024b63d617ff65e2","8121":"1ab4dbf725984354","8193":"6dc1541f767beb46","8949":"c8b07857bf5d2d79"}[chunkId] + ".css";
};